import { useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import { ShieldAlert } from 'lucide-react'
import { getImpersonationMeta, isImpersonationToken } from '../../utils/impersonation'
import { STORAGE_KEYS } from '../../utils/constants'
import { useAuth } from '../../contexts/AuthContext'

export default function ImpersonationBanner() {
  const navigate = useNavigate()
  const { logout } = useAuth()
  const token =
    typeof window !== 'undefined' ? localStorage.getItem(STORAGE_KEYS.AUTH_TOKEN) : null

  const meta = useMemo(() => {
    if (!token || !isImpersonationToken(token)) return null
    return getImpersonationMeta(token)
  }, [token])

  if (!meta) return null

  const exit = () => {
    logout()
    sessionStorage.removeItem('impersonationActive')
    try {
      window.close()
    } catch {
      /* ignore */
    }
    navigate('/login', { replace: true })
  }

  return (
    <div
      className="sticky top-0 z-50 flex items-center justify-between gap-3 px-4 py-2 text-sm text-amber-950"
      style={{ backgroundColor: '#FDE68A', borderBottom: '1px solid #F59E0B' }}
      role="status"
    >
      <div className="flex items-center gap-2 min-w-0">
        <ShieldAlert className="h-4 w-4 shrink-0" />
        <span className="truncate">
          Impersonating Merchant
          {meta.id != null ? ` #${meta.id}` : ''}
          {meta.impersonatedBy != null ? ` · by Super Master #${meta.impersonatedBy}` : ''}
          . Full write access — actions are audited.
        </span>
      </div>
      <button
        type="button"
        onClick={exit}
        className="shrink-0 rounded border border-amber-800/40 bg-white/80 px-3 py-1 text-xs font-semibold hover:bg-white"
      >
        Exit
      </button>
    </div>
  )
}
